export default __webpack_public_path__ + "static/media/Sid_logo.cf5f7ce1.svg";